import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { GradientIcon, TextButton } from 'seagull';
import { EditAI } from 'seagull/icons';
import { useLocaleKeys } from '~/i18n';
import styles from './HelpMeWriteTrigger.module.scss';
import { GetHelpMeWriteTriggerTID } from './HelpMeWriteTrigger.testIds';
export const HelpMeWriteTrigger = (param)=>{
    let { onClick, disabled = false, testId } = param;
    const { HelpMeWriteTriggerTestIds: testIds } = useMemo(()=>GetHelpMeWriteTriggerTID(testId), [
        testId
    ]);
    const { t: triggerTexts } = useLocaleKeys('notificationHelpMeWrite.trigger');
    return /*#__PURE__*/ _jsx(TextButton, {
        bi: {
            name: 'notification_help_me_write_open'
        },
        className: styles.trigger,
        prefixIcon: /*#__PURE__*/ _jsx("span", {
            "data-testid": testIds.Icon(),
            children: /*#__PURE__*/ _jsx(GradientIcon, {
                icon: /*#__PURE__*/ _jsx(EditAI, {})
            })
        }),
        hoverSkin: "magical",
        underline: "none",
        weight: "normal",
        skin: "primary",
        "aria-label": triggerTexts.ariaLabel(),
        disabled: disabled,
        onClick: onClick,
        testId: testIds.Root(),
        children: triggerTexts.label()
    });
};
